webpackJsonp([146451445218038],{

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  max-width: ", ";\n  margin: 0 auto;\n\n  a {\n    border-bottom: 1px solid ", ";\n    color: ", ";\n    font-weight: bold;\n    text-shadow: 2px 2px ", ",\n      -2px 2px ", ",\n      -2px -2px ", ",\n      -2px 2px ", ",\n      -2px 0 ", ",\n      2px 0 ", ";\n    display: inline-block;\n    line-height: 1.1;\n    text-decoration: none;\n    transition: 0.3s;\n\n    &:hover {\n      color: ", ";\n      border-color: ", ";\n    }\n  }\n"], ["\n  max-width: ", ";\n  margin: 0 auto;\n\n  a {\n    border-bottom: 1px solid ", ";\n    color: ", ";\n    font-weight: bold;\n    text-shadow: 2px 2px ", ",\n      -2px 2px ", ",\n      -2px -2px ", ",\n      -2px 2px ", ",\n      -2px 0 ", ",\n      2px 0 ", ";\n    display: inline-block;\n    line-height: 1.1;\n    text-decoration: none;\n    transition: 0.3s;\n\n    &:hover {\n      color: ", ";\n      border-color: ", ";\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose([""], [""]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: 1.9em;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1;\n  margin: 0 0 0.4em;\n\n  @media screen and (min-width: ", ") {\n    font-size: 2.6em;\n    letter-spacing: -0.03em;\n  }\n  @media screen and (min-width: ", ") {\n    font-size: 3.2em;\n    letter-spacing: -0.04em;\n  }\n"], ["\n  color: ", ";\n  font-size: 1.9em;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1;\n  margin: 0 0 0.4em;\n\n  @media screen and (min-width: ", ") {\n    font-size: 2.6em;\n    letter-spacing: -0.03em;\n  }\n  @media screen and (min-width: ", ") {\n    font-size: 3.2em;\n    letter-spacing: -0.04em;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: 1.5em;\n  font-weight: 300;\n  line-height: 1.15;\n  letter-spacing: 0em;\n  margin: 0 0 0.4em;\n\n  @media screen and (min-width: ", ") {\n    font-size: 1.7em;\n  }\n  @media screen and (min-width: ", ") {\n    font-size: 2em;\n  }\n"], ["\n  color: ", ";\n  font-size: 1.5em;\n  font-weight: 300;\n  line-height: 1.15;\n  letter-spacing: 0em;\n  margin: 0 0 0.4em;\n\n  @media screen and (min-width: ", ") {\n    font-size: 1.7em;\n  }\n  @media screen and (min-width: ", ") {\n    font-size: 2em;\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  font-size: 0.9em;\n  margin: 2rem 0 3rem;\n"], ["\n  font-size: 0.9em;\n  margin: 2rem 0 3rem;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  border-left: 2px solid ", ";\n  color: ", ";\n  padding: 0.3em 0.7em 0.4em;\n"], ["\n  background: ", ";\n  border-left: 2px solid ", ";\n  color: ", ";\n  padding: 0.3em 0.7em 0.4em;\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  line-height: 1.5;\n\n  .gatsby-resp-image-link {\n    margin: 2.5em 0;\n  }\n\n  h2,\n  h3 {\n    color: ", ";\n    font-size: 1.5em;\n    font-weight: 700;\n    line-height: 1.15;\n    margin: 1em 0 0.7em;\n    letter-spacing: -0.01em;\n\n    @media screen and (min-width: ", ") {\n      letter-spacing: -0.02em;\n      font-size: 1.7em;\n    }\n    @media screen and (min-width: ", ") {\n      letter-spacing: -0.03em;\n      font-size: 1.9em;\n    }\n  }\n\n  p {\n    margin: 0 0 1em;\n    font-size: 1.05em;\n\n    strong {\n      letter-spacing: -0.01em;\n      color: ", ";\n    }\n\n    @media screen and (min-width: ", ") {\n      font-size: 1.1em;\n    }\n    @media screen and (min-width: ", ") {\n      font-size: 1.2em;\n    }\n  }\n\n  blockquote {\n    border: 5px solid ", ";\n    font-style: italic;\n    margin: 2.5em 0;\n    padding: 1em 1.1em 1em 1.3em;\n    position: relative;\n\n    p {\n      margin: 0;\n    }\n\n    &::after,\n    &::before {\n      background: ", ";\n      content: \"\";\n      height: 5px;\n      left: 50%;\n      margin-left: -47%;\n      position: absolute;\n      top: -5px;\n      width: 94%;\n    }\n    &::after {\n      top: auto;\n      bottom: -5px;\n    }\n\n    @media screen and (min-width: ", ") {\n      padding: 1em 1.8em 1em 2em;\n    }\n  }\n\n  .gatsby-resp-image-link {\n    margin-left: -1.5em;\n    margin-right: -1.5em;\n    border: none;\n\n    @media screen and (min-width: ", ") {\n      margin-left: -3.2em;\n      margin-right: -3.2em;\n    }\n    @media screen and (min-width: ", ") {\n      margin-left: 0;\n      margin-right: 0;\n    }\n  }\n"], ["\n  color: ", ";\n  line-height: 1.5;\n\n  .gatsby-resp-image-link {\n    margin: 2.5em 0;\n  }\n\n  h2,\n  h3 {\n    color: ", ";\n    font-size: 1.5em;\n    font-weight: 700;\n    line-height: 1.15;\n    margin: 1em 0 0.7em;\n    letter-spacing: -0.01em;\n\n    @media screen and (min-width: ", ") {\n      letter-spacing: -0.02em;\n      font-size: 1.7em;\n    }\n    @media screen and (min-width: ", ") {\n      letter-spacing: -0.03em;\n      font-size: 1.9em;\n    }\n  }\n\n  p {\n    margin: 0 0 1em;\n    font-size: 1.05em;\n\n    strong {\n      letter-spacing: -0.01em;\n      color: ", ";\n    }\n\n    @media screen and (min-width: ", ") {\n      font-size: 1.1em;\n    }\n    @media screen and (min-width: ", ") {\n      font-size: 1.2em;\n    }\n  }\n\n  blockquote {\n    border: 5px solid ", ";\n    font-style: italic;\n    margin: 2.5em 0;\n    padding: 1em 1.1em 1em 1.3em;\n    position: relative;\n\n    p {\n      margin: 0;\n    }\n\n    &::after,\n    &::before {\n      background: ", ";\n      content: \"\";\n      height: 5px;\n      left: 50%;\n      margin-left: -47%;\n      position: absolute;\n      top: -5px;\n      width: 94%;\n    }\n    &::after {\n      top: auto;\n      bottom: -5px;\n    }\n\n    @media screen and (min-width: ", ") {\n      padding: 1em 1.8em 1em 2em;\n    }\n  }\n\n  .gatsby-resp-image-link {\n    margin-left: -1.5em;\n    margin-right: -1.5em;\n    border: none;\n\n    @media screen and (min-width: ", ") {\n      margin-left: -3.2em;\n      margin-right: -3.2em;\n    }\n    @media screen and (min-width: ", ") {\n      margin-left: 0;\n      margin-right: 0;\n    }\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: 0.8em;\n  padding: 4em 0 2em;\n  text-align: right;\n"], ["\n  color: ", ";\n  font-size: 0.8em;\n  padding: 4em 0 2em;\n  text-align: right;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Author = __webpack_require__(139);
	
	var _Author2 = _interopRequireDefault(_Author);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var config = __webpack_require__(15);
	
	var Wrapper = _styledComponents2.default.article(_templateObject, function (props) {
	  return props.theme.post.sizes.maxWidth;
	}, function (props) {
	  return props.theme.post.colors.linkHover;
	}, function (props) {
	  return props.theme.post.colors.link;
	}, function (props) {
	  return props.theme.post.backgrounds.wrapper;
	}, function (props) {
	  return props.theme.post.backgrounds.wrapper;
	}, function (props) {
	  return props.theme.post.backgrounds.wrapper;
	}, function (props) {
	  return props.theme.post.backgrounds.wrapper;
	}, function (props) {
	  return props.theme.post.backgrounds.wrapper;
	}, function (props) {
	  return props.theme.post.backgrounds.wrapper;
	}, function (props) {
	  return props.theme.post.colors.linkHover;
	}, function (props) {
	  return props.theme.post.colors.link;
	});
	
	var Header = _styledComponents2.default.header(_templateObject2);
	
	var Title = _styledComponents2.default.h1(_templateObject3, function (props) {
	  return props.theme.post.colors.title;
	}, function (props) {
	  return props.theme.mediaQueryThresholds.M;
	}, function (props) {
	  return props.theme.mediaQueryThresholds.XL;
	});
	
	var SubTitle = _styledComponents2.default.h2(_templateObject4, function (props) {
	  return props.theme.post.colors.subTitle;
	}, function (props) {
	  return props.theme.mediaQueryThresholds.M;
	}, function (props) {
	  return props.theme.mediaQueryThresholds.XL;
	});
	
	var Meta = _styledComponents2.default.div(_templateObject5);
	
	var PostDate = _styledComponents2.default.span(_templateObject6, function (props) {
	  return props.theme.post.backgrounds.meta;
	}, function (props) {
	  return props.theme.post.colors.metaBorder;
	}, function (props) {
	  return props.theme.post.colors.meta;
	});
	
	var Content = _styledComponents2.default.div(_templateObject7, function (props) {
	  return props.theme.post.colors.text;
	}, function (props) {
	  return props.theme.post.colors.title;
	}, function (props) {
	  return props.theme.mediaQueryThresholds.M;
	}, function (props) {
	  return props.theme.mediaQueryThresholds.XL;
	}, function (props) {
	  return props.theme.post.colors.bold;
	}, function (props) {
	  return props.theme.mediaQueryThresholds.M;
	}, function (props) {
	  return props.theme.mediaQueryThresholds.XL;
	}, function (props) {
	  return props.theme.post.colors.blockquoteFrame;
	}, function (props) {
	  return props.theme.post.backgrounds.wrapper;
	}, function (props) {
	  return props.theme.mediaQueryThresholds.L;
	}, function (props) {
	  return props.theme.mediaQueryThresholds.M;
	}, function (props) {
	  return props.theme.mediaQueryThresholds.XL;
	});
	
	var Footer = _styledComponents2.default.footer(_templateObject2);
	
	var Copyright = _styledComponents2.default.p(_templateObject8, function (props) {
	  return props.theme.post.colors.copyright;
	});
	
	var Article = function Article(_ref) {
	  var post = _ref.post;
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      Header,
	      null,
	      _react2.default.createElement(
	        Title,
	        null,
	        post.frontmatter.title
	      ),
	      _react2.default.createElement(
	        SubTitle,
	        null,
	        post.frontmatter.subTitle
	      ),
	      _react2.default.createElement(
	        Meta,
	        null,
	        _react2.default.createElement(
	          PostDate,
	          null,
	          post.frontmatter.date
	        )
	      )
	    ),
	    _react2.default.createElement(Content, { dangerouslySetInnerHTML: { __html: post.html } }),
	    _react2.default.createElement(
	      Footer,
	      null,
	      _react2.default.createElement(_Author2.default, null),
	      _react2.default.createElement(
	        Copyright,
	        null,
	        config.copyright
	      )
	    )
	  );
	};
	
	exports.default = Article;
	module.exports = exports["default"];

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  border-top: 2px dotted ", ";\n  margin: 3em 0 0;\n  padding: 2em 0 0;\n"], ["\n  border-top: 2px dotted ", ";\n  margin: 3em 0 0;\n  padding: 2em 0 0;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  line-height: 1.4;\n  margin: 0;\n  strong {\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n  line-height: 1.4;\n  margin: 0;\n  strong {\n    color: ", ";\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  border: 1px solid ", ";\n  border-radius: 100%;\n  float: left;\n  height: auto;\n  width: 40px;\n  margin: -0.5em 1em 0 0;\n"], ["\n  border: 1px solid ", ";\n  border-radius: 100%;\n  float: left;\n  height: auto;\n  width: 40px;\n  margin: -0.5em 1em 0 0;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _avatar = __webpack_require__(577);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var config = __webpack_require__(15);
	
	
	var Wrapper = _styledComponents2.default.section(_templateObject, function (props) {
	  return props.theme.post.colors.authorBorder;
	});
	
	var Text = _styledComponents2.default.p(_templateObject2, function (props) {
	  return props.theme.post.colors.author;
	}, function (props) {
	  return props.theme.post.colors.bold;
	});
	
	var Avatar = _styledComponents2.default.img(_templateObject3, function (props) {
	  return props.theme.post.colors.authorBorder;
	});
	
	var Author = function Author() {
	  var content = "<strong>" + config.authorName + "</strong> " + config.authorDescription;
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(Avatar, { src: _avatar2.default, alt: "author" }),
	    _react2.default.createElement(Text, { dangerouslySetInnerHTML: { __html: content } })
	  );
	};
	
	exports.default = Author;
	module.exports = exports["default"];

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/avatar.f0bfc962.jpg";

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _siteConfig = __webpack_require__(15);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Seo = function (_Component) {
	  _inherits(Seo, _Component);
	
	  function Seo() {
	    _classCallCheck(this, Seo);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Seo.prototype.render = function render() {
	    var _props = this.props,
	        postNode = _props.postNode,
	        postPath = _props.postPath,
	        postSEO = _props.postSEO;
	
	    var title = void 0;
	    var description = void 0;
	    var image = void 0;
	    var postURL = void 0;
	    var realPrefix = _siteConfig2.default.pathPrefix === "/" ? "" : _siteConfig2.default.pathPrefix;
	    if (postSEO) {
	      var postMeta = postNode.frontmatter;
	      title = postMeta.title;
	      description = postNode.subTitle;
	      postURL = _siteConfig2.default.siteUrl + realPrefix + postPath;
	    } else {
	      title = _siteConfig2.default.siteTitle;
	      description = _siteConfig2.default.siteDescription;
	      image = _siteConfig2.default.siteLogo;
	    }
	    var blogURL = _siteConfig2.default.siteUrl + _siteConfig2.default.pathPrefix;
	    var schemaOrgJSONLD = [{
	      "@context": "http://schema.org",
	      "@type": "WebSite",
	      url: blogURL,
	      name: title,
	      alternateName: _siteConfig2.default.siteLongTitle ? _siteConfig2.default.siteLongTitle : ""
	    }];
	    if (postSEO) {
	      schemaOrgJSONLD.push([{
	        "@context": "http://schema.org",
	        "@type": "BreadcrumbList",
	        itemListElement: [{
	          "@type": "ListItem",
	          position: 1,
	          item: {
	            "@id": postURL,
	            name: title,
	            image: image
	          }
	        }]
	      }, {
	        "@context": "http://schema.org",
	        "@type": "BlogPosting",
	        url: blogURL,
	        name: title,
	        alternateName: _siteConfig2.default.siteTitleAlt ? _siteConfig2.default.siteTitleAlt : "",
	        headline: title,
	        image: {
	          "@type": "ImageObject",
	          url: image
	        },
	        description: description
	      }]);
	    }
	    return _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement("meta", { name: "description", content: description }),
	      _react2.default.createElement("meta", { name: "image", content: image }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify(schemaOrgJSONLD)
	      ),
	      _react2.default.createElement("meta", { property: "og:locale", content: "de_DE" }),
	      _react2.default.createElement("meta", { property: "og:site_name", content: _siteConfig2.default.ogSiteName }),
	      _react2.default.createElement("meta", { property: "og:url", content: postSEO ? postURL : blogURL }),
	      postSEO ? _react2.default.createElement("meta", { property: "og:type", content: "article" }) : null,
	      _react2.default.createElement("meta", { property: "og:title", content: title }),
	      _react2.default.createElement("meta", { property: "og:description", content: description }),
	      _react2.default.createElement("meta", { property: "og:image", content: image }),
	      _react2.default.createElement("meta", {
	        property: "fb:app_id",
	        content: _siteConfig2.default.siteFBAppID ? _siteConfig2.default.siteFBAppID : ""
	      }),
	      _react2.default.createElement("meta", { name: "twitter:card", content: "summary_large_image" }),
	      _react2.default.createElement("meta", {
	        name: "twitter:creator",
	        content: _siteConfig2.default.userTwitter ? _siteConfig2.default.userTwitter : ""
	      }),
	      _react2.default.createElement("meta", { name: "twitter:title", content: title }),
	      _react2.default.createElement("meta", { name: "twitter:url", content: _siteConfig2.default.siteUrl }),
	      _react2.default.createElement("meta", { name: "twitter:description", content: description }),
	      _react2.default.createElement("meta", { name: "twitter:image", content: image })
	    );
	  };
	
	  return Seo;
	}(_react.Component);
	
	exports.default = Seo;
	module.exports = exports["default"];

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  0% {\n    opacity: 0.00001;\n  }\n  10% {\n    opacity: 1;\n  }\n"], ["\n  0% {\n    opacity: 0.00001;\n  }\n  10% {\n    opacity: 1;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  bottom: 0;\n  left: 0;\n  opacity: 1;\n  margin-top: ", "px;\n  overflow: auto;\n  padding: 1.5em 1.5em 5.5em;\n  position: absolute;\n  right: 0;\n  top: 0;\n\n  @media screen and (min-width: ", ") {\n    animation-name: ", ";\n    animation-duration: 5s;\n    padding: 3em 3.5em 6em;\n  }\n  @media screen and (min-width: ", ") {\n    left: ", ";\n    padding: 3.5em 3.5em 3em;\n  }\n"], ["\n  background: ", ";\n  bottom: 0;\n  left: 0;\n  opacity: 1;\n  margin-top: ", "px;\n  overflow: auto;\n  padding: 1.5em 1.5em 5.5em;\n  position: absolute;\n  right: 0;\n  top: 0;\n\n  @media screen and (min-width: ", ") {\n    animation-name: ", ";\n    animation-duration: 5s;\n    padding: 3em 3.5em 6em;\n  }\n  @media screen and (min-width: ", ") {\n    left: ", ";\n    padding: 3.5em 3.5em 3em;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Seo = __webpack_require__(85);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _Author = __webpack_require__(139);
	
	var _Author2 = _interopRequireDefault(_Author);
	
	var _Article = __webpack_require__(228);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var config = __webpack_require__(15);
	
	
	var wrapperShowUp = (0, _styledComponents.keyframes)(_templateObject);
	
	var Wrapper = _styledComponents2.default.main(_templateObject2, function (props) {
	  return props.theme.post.backgrounds.wrapper;
	}, function (props) {
	  return props.theme.topBar.sizes.height;
	}, function (props) {
	  return props.theme.mediaQueryThresholds.M;
	}, wrapperShowUp, function (props) {
	  return props.theme.mediaQueryThresholds.L;
	}, function (props) {
	  return props.navigatorIsActive ? props.theme.navigator.sizes.asideWidth : 0;
	});
	
	var BlogPostTemplate = function (_React$Component) {
	  _inherits(BlogPostTemplate, _React$Component);
	
	  function BlogPostTemplate() {
	    _classCallCheck(this, BlogPostTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BlogPostTemplate.prototype.render = function render() {
	    var post = this.props.data.markdownRemark;
	
	    return _react2.default.createElement(
	      Wrapper,
	      { navigatorIsActive: this.props.navigatorIsActive },
	      _react2.default.createElement(_reactHelmet2.default, { title: post.frontmatter.title + " | " + config.siteTitle }),
	      _react2.default.createElement(_Seo2.default, { postPath: post.frontmatter.path, postNode: post, postSEO: true }),
	      _react2.default.createElement(_Article2.default, { post: post })
	    );
	  };
	
	  return BlogPostTemplate;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    navigatorIsActive: state.posts.length
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BlogPostTemplate);
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-project-template-js-eabaa0156f0e8a04d835.js